<ng-container
  *appLet="{
    currentCulture: culture$ | async
  } as $comp"
>
  <ng-container *ngIf="$comp.currentCulture">
    <ng-container
      *appLet="
        date | date: format : undefined : $comp.currentCulture as dateFormatted
      "
    >
      <span>
        <span>{{ dateFormatted }}</span>
        <ng-container *ngIf="secondDate">
          <ng-container
            *appLet="
              secondDate
                | date
                  : format
                  : undefined
                  : $comp.currentCulture as secondDateFormatted
            "
          >
            <span *ngIf="dateFormatted !== secondDateFormatted"> - </span>
            <span *ngIf="dateFormatted !== secondDateFormatted">{{
              secondDateFormatted
            }}</span>
          </ng-container>
        </ng-container>
      </span>
    </ng-container>
  </ng-container>
</ng-container>
